import React, { createContext, useState, useContext, useEffect } from 'react';
import { translations } from '../translations/translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(localStorage.getItem('language') || 'en');

    useEffect(() => {
        localStorage.setItem('language', language);
    }, [language]);

    const t = (key, defaultText) => {
        if (!key) return '';
        const langDict = translations[language];
        if (langDict && langDict[key] !== undefined && langDict[key] !== '') {
            return langDict[key];
        }
        const enDict = translations['en'];
        if (enDict && enDict[key] !== undefined && enDict[key] !== '') {
            return enDict[key];
        }
        return defaultText || '';
    };

    const toggleLanguage = (lang) => {
        setLanguage(lang);
    };

    return (
        <LanguageContext.Provider value={{ language, t, toggleLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};
